export const BASE_PARAMS = {
    urlDownloadServiceMac: 'https://files.wildix.com/integrations/osx/wiservice/WIService.pkg',
    urlDownloadServiceWin: 'https://files.wildix.com/integrations/win/wiservice/SetupWIService.exe',
    minVersionWiService: '3.10.4',
    sharingTabString: 'web-contents-media-stream'
};

export const STATUSES = {
    OPENED: 'OPENED',
    CLOSED: 'CLOSED',
    PENDING: 'PENDING',
    REQUESTING: 'REQUESTING',
    PAUSED: 'PAUSED',
    STOPPED: 'STOPPED'
};
export const REQUEST_TYPES = {
    CONTROL_NOT_INSTALLED: 'REQUEST_CONTROL_NOT_INSTALLED',
    CONTROL: 'REQUEST_CONTROL',
    CONTROL_CLOSE: 'REQUEST_CONTROL_CLOSE',
    CONTROL_WAS_STOPPED: 'REQUEST_CONTROL_WAS_STOPPED',
    CONTROL_NOT_ESTABLISHED: 'REQUEST_CONTROL_NOT_ESTABLISHED',
    CONTROL_BUSY: 'REQUEST_CONTROL_BUSY',
    CONTROL_REJECTED_TAB: 'CONTROL_REJECTED_TAB',
    CONTROL_REJECTED_FIREFOX: 'CONTROL_REJECTED_FIREFOX',
    CONTROL_APPROVED: 'REQUEST_CONTROL_APPROVED',
    CONTROL_REJECTED: 'REQUEST_CONTROL_REJECTED',
    CONTROL_DIALOG_REQUEST: 'CONTROL_DIALOG_REQUEST'
};

export const WEBRTC_TYPES = {
    OFFER: 'offer',
    CONTROL_OFFER: 'control_offer',
    TYPE_MESSAGE: 'json-message'
};

export const WISERVICE_TYPES = {
    messageType: 'M_SCREEN_CONTROL',
    messageMouseMove: 'M_MOUSE',
    commandStart: 'start',
    commandStop: 'stop',
    commandAction: 'action',
    serviceStopped: 'stopped',
    serviceConnected: 'connected'
};

/**
 * Types of remote-control events.
 *
 * @readonly
 * @enum {string}
 */
export const EVENTS = {
    mouseleave: 'mouseleave',
    mouseenter: 'mouseenter',
    mousemove: 'mousemove',
    mousedown: 'mousedown',
    mouseup: 'mouseup',
    mousedblclick: 'mousedblclick',
    mousescroll: 'mousescroll',
    keydown: 'keydown',
    keyup: 'keyup'
};

export const FIREHOSE_EVENTS = {
    requestApproved: 'remote control'
};

export const WIS_CONTROL_EVENTS = {
    STARTED: 'started',
    TYPE_CONTROL: 'control',
    RUNNING: 'running',
    STOPPED: 'notrunning'
};

export const CONTROL_TIMEOUTS = {
    mouseLeaveDelay: 5000,
    peerConnectionStuckDelay: 5000,
    queueDialogDelay: 600
};

export const NOTIFICATION_FROM_USER_BY_KEY = {
    [REQUEST_TYPES.CONTROL_APPROVED]: 'controlSharing.remoteControlAllowedMessage',
    [REQUEST_TYPES.CONTROL_REJECTED]: 'controlSharing.remoteControlDeniedMessage',
    [REQUEST_TYPES.CONTROL_CLOSE]: 'controlSharing.remoteControlDisabledMessage',
    [REQUEST_TYPES.CONTROL_WAS_STOPPED]: 'controlSharing.controlSharingWasStopped',
    [REQUEST_TYPES.CONTROL_NOT_ESTABLISHED]: 'controlSharing.dataChannelNotCreated',
    [REQUEST_TYPES.CONTROL_BUSY]: 'controlSharing.sharingAlreadyLaunched'
};

export const DISCO_WILDIX_REMOTE_CONTROL_FEATURE = 'http://jitsi.org/meet/wildixremotecontrol';
